module.exports = __webpack_public_path__ + "img/logo.c6a28f5d.jpg";